import { render, staticRenderFns } from "./RealEstateAccommodationsTable.vue?vue&type=template&id=ebc7b7c2&"
import script from "./RealEstateAccommodationsTable.vue?vue&type=script&lang=js&"
export * from "./RealEstateAccommodationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAccommodationsTable.vue?vue&type=style&index=0&id=ebc7b7c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports